import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '../../../../../reducers';
import { loadCompanyInfo, updateCompanyInfoCurrentDatabaseId, updateCompanyInfoSelectedDatabaseId } from '../drill-down.actions';
import { hasCompanyInfoLoaded, selectCompanyInfo, selectCompanyInfoSelectedDatabaseId } from '../drill-down.selectors';
import { NonBvdComparableLinks, UrlQueryParamsPlaceholder } from '../../../../../shared/_constants';
import { DatabaseType } from '../../../../_study_constants';
import { DrillDownSectionBaseComponent } from './base/drill-down-section-base.component';
import { CompanyInfo } from '../../../../models/company-info.model';

@Component({
  selector: 'app-drill-down-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyInfoComponent extends DrillDownSectionBaseComponent implements OnInit, OnDestroy {
  companyInfo$: Observable<CompanyInfo>;
  selectedDatabaseId: number;
  hasCompanyInfoLoaded: boolean;

  constructor(store: Store<AppState>) {
    super(store);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.companyInfo$ = this.store.pipe(select(selectCompanyInfo));

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectCompanyInfoSelectedDatabaseId))
      .subscribe((id) => {
        this.selectedDatabaseId = id;
      });

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(hasCompanyInfoLoaded))
      .subscribe((isLoaded) => {
        this.hasCompanyInfoLoaded = isLoaded;
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onCompanyInfoDatabaseChange(id: string) {
    const databaseId = +id;
    const comparableId = this.companyData.comparableId;

    this.store.dispatch(updateCompanyInfoSelectedDatabaseId({ id: comparableId, databaseId }));

    if (this.hasCompanyInfoLoaded) {
      this.store.dispatch(updateCompanyInfoCurrentDatabaseId({ id: comparableId, databaseId }));
      return;
    }

    this.store.dispatch(loadCompanyInfo({ id: comparableId, uniqueId: this.companyData.uniqueId, databaseId }));
  }

  oneSourceUrl(bvDId: string): string {
    return NonBvdComparableLinks.ONESOURCE_URL.replace(UrlQueryParamsPlaceholder.VENDOR_XREF, bvDId);
  }

  secUrl(cik: string): string {
    return cik ? NonBvdComparableLinks.SEC_URL.replace(UrlQueryParamsPlaceholder.KEY_ID, cik) : NonBvdComparableLinks.SEC_DEFAULT_URL;
  }

  get isOneSource(): boolean {
    return this.selectedDatabaseId === DatabaseType.OneSource;
  }

  get isNonBvd(): boolean {
    return (
      this.selectedDatabaseId === DatabaseType.OneSource ||
      this.selectedDatabaseId === DatabaseType.CompustatGlobal ||
      this.selectedDatabaseId === DatabaseType.CompustatNA
    );
  }
}
